import { useEffect } from 'react'
import { AlertTriangle, X } from 'lucide-react'

export default function ConfirmDialog({
    open,
    title,
    description,
    confirmLabel = 'Confirma',
    cancelLabel = 'Anuleaza',
    tone = 'default',
    loading = false,
    onClose,
    onConfirm,
}) {
    useEffect(() => {
        if (!open) return undefined

        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && !loading) {
                onClose()
            }
        }

        window.addEventListener('keydown', handleKeyDown)
        return () => window.removeEventListener('keydown', handleKeyDown)
    }, [loading, onClose, open])

    if (!open) return null

    return (
        <div className="modal-overlay" onClick={loading ? undefined : onClose}>
            <div
                className={`confirm-dialog ${tone}`.trim()}
                onClick={(event) => event.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="confirm-dialog-title"
            >
                <div className="confirm-dialog-header">
                    <div className={`confirm-dialog-icon ${tone}`.trim()}>
                        <AlertTriangle size={18} aria-hidden="true" />
                    </div>
                    <div className="confirm-dialog-copy">
                        <h3 id="confirm-dialog-title">{title}</h3>
                        <p>{description}</p>
                    </div>
                    <button
                        type="button"
                        className="modal-close"
                        onClick={loading ? undefined : onClose}
                        aria-label="Inchide dialogul"
                    >
                        <X size={18} />
                    </button>
                </div>
                <div className="confirm-dialog-actions">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        onClick={onClose}
                        disabled={loading}
                    >
                        {cancelLabel}
                    </button>
                    <button
                        type="button"
                        className={`btn ${tone === 'danger' ? 'btn-danger' : 'btn-primary'}`.trim()}
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? 'Se proceseaza...' : confirmLabel}
                    </button>
                </div>
            </div>
        </div>
    )
}
